import type { Observable } from 'rxjs/Observable';
import { baseUrlSelector } from '@atlassian/jira-servicedesk-automation-common/src/state/selectors/app-props';
import deleteRule from '../../rest/rule/delete';
import type { State } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State, ruleSetId: number): Observable<number> => {
	const baseUrl = baseUrlSelector(state);
	return deleteRule(baseUrl, ruleSetId);
};
